module.exports = __webpack_public_path__ + "static/colouring_in_augustus-1feb8f83e31504ea67d110bde440b9ae.pdf";